import { isPathBasedEmbeddedMode } from '../constants/config';
import { getActiveSsoProviderId } from './embeddedSsoSession';

// The storage (sessionStorage for path-based embedded mode, localStorage
// otherwise) and key are resolved on every access rather than bound at module
// load, so iframe-embedded autologin sessions can namespace the token per SSO
// provider. See `embeddedSsoSession.ts` for the rationale.

const LEGACY_TOKEN_KEY = 'secureToken';

const tokenStorage = (): Storage =>
  isPathBasedEmbeddedMode() ? sessionStorage : localStorage;

const tokenKey = (): string => {
  const providerId = getActiveSsoProviderId();
  return providerId ? `${LEGACY_TOKEN_KEY}:${providerId}` : LEGACY_TOKEN_KEY;
};

export const getAuthToken = () => tokenStorage().getItem(tokenKey());

export const setAuthToken = (token: string) =>
  tokenStorage().setItem(tokenKey(), token);

export const clearAuthToken = () => tokenStorage().removeItem(tokenKey());
